export enum LocalStorageKeys {
  USER_NAME = 'name',
  SOUND_ENABLED = 'soundEnabled',
  INVITE_TIP_SEEN = 'inviteTipSeen',
}
